import type { MentionContext, MentionKind, MentionResolver, ResolvedMention } from './types'

class MentionRegistry {
  private resolvers = new Map<MentionKind, MentionResolver>()

  register(kind: MentionKind, resolver: MentionResolver): void {
    this.resolvers.set(kind, resolver)
  }

  get(kind: MentionKind): MentionResolver | undefined {
    return this.resolvers.get(kind)
  }

  kinds(): MentionKind[] {
    return Array.from(this.resolvers.keys())
  }

  async search(
    query: string,
    ctx: MentionContext
  ): Promise<{ kind: MentionKind; candidates: ResolvedMention[] }[]> {
    const results = await Promise.all(
      Array.from(this.resolvers.entries()).map(async ([kind, resolver]) => {
        const res = await resolver(query, ctx)
        return { kind, candidates: res.ok ? res.candidates : [] }
      })
    )
    return results.filter(r => r.candidates.length > 0)
  }
}

export const mentionRegistry = new MentionRegistry()
